module.exports = __webpack_public_path__ + "static/media/3wise_owl_take5.1969f1e5.gif";